import Slider from "@mui/material/Slider";
import classes from "./revenueSlider.module.scss";

const TRACK_HEIGHT = 14;

const SLIDER_SX = {
  width: "100%",
  maxWidth: "100%",
  boxSizing: "border-box",
  height: 44,
  padding: "15px 0",
  margin: 0,
  color: "#1c32f3",
  "& .MuiSlider-rail": {
    height: TRACK_HEIGHT,
    borderRadius: 999,
    backgroundColor: "#eef3ff",
    opacity: 1,
  },
  "& .MuiSlider-track": {
    height: TRACK_HEIGHT,
    borderRadius: 999,
    backgroundColor: "#1c32f3",
    border: "none",
  },
  "& .MuiSlider-thumb": {
    width: 3,
    height: 32,
    borderRadius: 999,
    backgroundColor: "#1c32f3",
    boxShadow: "none",
    border: "none",
    "&:hover, &.Mui-focusVisible, &.Mui-active": {
      boxShadow: "none",
    },
    "&::before": {
      display: "none",
    },
  },
  "& .MuiSlider-mark": {
    width: 6,
    height: 6,
    borderRadius: "50%",
    backgroundColor: "#5d78ff",
    opacity: 1,
    top: "50%",
    transform: "translate(-50%, -50%)",
  },
  "& .MuiSlider-markActive": {
    backgroundColor: "#0b1fc9",
    opacity: 1,
  },
  "&.Mui-disabled": {
    color: "#1c32f3",
    "& .MuiSlider-rail": {
      opacity: 0.45,
    },
    "& .MuiSlider-track": {
      opacity: 0.45,
    },
    "& .MuiSlider-mark, & .MuiSlider-markActive": {
      opacity: 0.45,
    },
  },
};

const RevenueSlider = ({
  value,
  max,
  marks,
  disabled = false,
  onChange,
  onChangeCommitted,
  ariaLabel = "Yearly revenue",
  startLabel = "0 Ft",
  endLabel = "2+ mrd Ft",
}) => (
  <div className={classes.sliderWrap}>
    <Slider
      aria-label={ariaLabel}
      value={value}
      min={0}
      max={max}
      step={1}
      marks={marks}
      disabled={disabled}
      onChange={onChange}
      onChangeCommitted={onChangeCommitted}
      sx={SLIDER_SX}
    />
    <div className={classes.sliderRangeLabels}>
      <span>{startLabel}</span>
      <span>{endLabel}</span>
    </div>
  </div>
);

export default RevenueSlider;
